import * as PIXI from "pixi.js";
import Layers from "../../../layers/Layers";
import ProtractorRendererFactory from "./ProtractorRendererFactory";


export default class ProtractorRenderer extends PIXI.Container {
  private Layers = Layers.getInstance();
  public bg = this.addChild(new PIXI.Graphics());
  public rotateLButton = this.addChild(new PIXI.Graphics());
  public rotateRButton = this.addChild(new PIXI.Graphics());
  public markAngleLButton = this.addChild(new PIXI.Graphics);
  public markAngleRButton = this.addChild(new PIXI.Graphics);
  private graduations = this.addChild(new PIXI.Graphics());
  private Angles!: PIXI.Text[];

  constructor() {
    super();
    this.x = 500;
    this.y = 600;

    this.addToLayer();
    this.draw();
  }
  private addToLayer = () => this.Layers.UITop.addChild(this);
  private deactiveEventMode = () => [this.graduations, ...this.Angles].forEach(elm => elm.eventMode = 'none')

  draw() {
    ProtractorRendererFactory.drawBackground(this.bg);
    ProtractorRendererFactory.drawGraduations(this.graduations);
    ProtractorRendererFactory.drawRotateButtons(this.rotateLButton, this.rotateRButton);
    this.Angles = ProtractorRendererFactory.drawAngleLabels(this);
    this.drawMarkAngleBtn(this.markAngleRButton, 0, 0x00ff00);
    this.drawMarkAngleBtn(this.markAngleLButton, Math.PI, "yellow");
    this.deactiveEventMode();
  }
  drawMarkAngleBtn(btn: PIXI.Graphics, rot: number, c: number | string) {
    ProtractorRendererFactory.drawMarkAngleButton(btn, rot, c);
  }
}